export default __webpack_public_path__ + "static/media/banner.5615b287.jpeg";